

define(['angular', 'squid/index', 'text!./template.html'], function (angular, index, template) {

    return angular.module('hermes.page.xo-sidebar.directive', ['squid']).directive('xoSidebar', function () {

        return {
            template: template,

            scope: {
                backUri: '=',
                parentModel: '='
            },

            link: function link($scope, element, attr) {

                $scope.$on('populated', function () {
                    angular.element('body').addClass('trayOpen');
                    angular.element('#wrapper').addClass('maskMember');

                    var payButton = angular.element('.confirmButton');

                    if (payButton) {
                        payButton.attr('disabled', true);
                    }
                });

                $scope.$on('$destroy', function () {
                    angular.element('body').removeClass('trayOpen');

                    var payButton = angular.element('.confirmButton');

                    if (payButton) {
                        payButton.attr('disabled', false);
                    }
                });
            },

            controller: function controller($scope, $rootScope, $window, $state, $util, $populate) {

                $util.assert($scope.backUri, 'Expected backUri');

                $populate($scope);

                $scope.token = $rootScope.token;

                $scope.onPageClick = function ($event) {
                    $event.stopPropagation();
                };

                $scope.close = function () {
                    $state.go($scope.backUri);
                };

                $scope.callbacks = {
                    done: function done() {
                        $state.go($scope.backUri);
                    }
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar/directive.js
// module id = ./pages/xo-sidebar/directive.js
// module chunks = 1